import { Helmet } from "react-helmet";
import { Container, Row, Col } from "reactstrap";

import BackIcon from "../../components/BackIcon/BackIcon";
import NewPageForm from "../../components/Form/NewPageForm";

const NewPage = () => {
  return (
    <>
      <Helmet>
        <style>{"body { background-color: lightgray; }"}</style>
      </Helmet>
      <Container>
        <BackIcon />
        <Row>
          <Col>
            <NewPageForm />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NewPage;
